import {
    Box,
    Button,
    Checkbox,
    Container,
    Divider,
    FormControl,
    FormLabel,
    Heading,
    HStack,
    Input,
    Link,
    Stack,
    Text,
} from '@chakra-ui/react'
import { PasswordField } from './PasswordField'
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../contexts/AuthContext';
import { useCompany } from '../contexts/CompanyContext';

export const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [error, setError] = useState('');
    const [isCredentialsError, setIsCredentialsError] = useState(false);
    const navigate = useNavigate();
    const {isLogged} = useContext(AuthContext);
    const {selectedCompany, setSelectedCompany} = useCompany();

    // If the user is already logged in, redirect to the dashboard
    useEffect(() => {
        isLogged() && navigate('/dashboard');
    }, [isLogged, navigate]);

    // Handle the login form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/login', { email, password, remember });
            localStorage.setItem('token', response.data.access_token.toString());
            setSelectedCompany(null);   // Clear selected company on login
            window.location.href = '/dashboard';
        } catch (error) {
            if (error.response.status === 401) {
                console.error('Invalid credentials');
                setIsCredentialsError(true);
                setError('Invalid credentials');
            }else{
                setError('Something went wrong. Please try again later.');
            }
        }
    };

    return (
        <Container maxW="lg" py={{ base: '12', md: '24' }} px={{ base: '0', sm: '8' }}>
            <Stack spacing="8">
                <Stack spacing="6">
                    <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
                        <Heading size={{ base: 'xs', md: 'sm' }}>Log in to your account</Heading>
                    </Stack>
                </Stack>
                <Box
                    py={{ base: '0', sm: '8' }}
                    px={{ base: '4', sm: '10' }}
                    bg={{ base: 'transparent', sm: 'bg.surface' }}
                    boxShadow={{ base: 'none', sm: 'md' }}
                    borderRadius={{ base: 'none', sm: 'xl' }}
                >
                    <form onSubmit={handleSubmit}>
                        <Stack spacing="6">
                            {isCredentialsError && (
                                <Text color="red.500" fontSize="sm" textAlign="center">
                                    {error}
                                </Text>
                            )}
                            <Stack spacing="5">
                                <FormControl>
                                    <FormLabel htmlFor="email">Email</FormLabel>
                                    <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                </FormControl>
                                <PasswordField onChange={setPassword} password={password}/>
                            </Stack>
                            <HStack justify="space-between">
                                <Checkbox checked={remember} onChange={(e) => setRemember(!remember)}>Remember me</Checkbox>
                                <Button variant="text" size="sm">
                                    Forgot password?
                                </Button>
                            </HStack>
                            <Stack spacing="6">
                                {/* <Button onClick={handleSubmit}>Sign in</Button> */}
                                <Button type="submit">Sign in</Button>
                                <HStack>
                                    <Divider />
                                </HStack>
                            </Stack>
                            <Stack spacing="6">
                                {/* <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
                                    <Text color="fg.muted">
                                        Don't have an account? <Link href="#">Sign up</Link>
                                    </Text>
                                </Stack> */}
                            </Stack>
                        </Stack>
                    </form>
                </Box>
            </Stack>
        </Container>
    )
}